function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 34.5,
  cy: 34,
  r: 32,
  fill: "#E6FAF0"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M50.5 6.281A31.853 31.853 0 0034.5 2c-17.673 0-32 14.327-32 32 0 17.673 14.327 32 32 32 17.673 0 32-14.327 32-32 0-3.678-.62-7.21-1.763-10.5",
  stroke: "#04CE6D",
  strokeWidth: 3.5,
  strokeLinecap: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5 35.154L30.96 43 46.5 26",
  stroke: "#04CE6D",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgIcoOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}
export default __webpack_public_path__ + "/img/ico-ok.svg";
export { SvgIcoOk as ReactComponent };